/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskIndicatorSummary } from './RiskIndicatorSummary';
import {
  RiskIndicatorSummaryFromJSON,
  RiskIndicatorSummaryFromJSONTyped,
  RiskIndicatorSummaryToJSON,
} from './RiskIndicatorSummary';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';
import type { TopMetric } from './TopMetric';
import { TopMetricFromJSON, TopMetricFromJSONTyped, TopMetricToJSON } from './TopMetric';

/**
 *
 * @export
 * @interface AiModelWithAssessment
 */
export interface AiModelWithAssessment {
  /**
   *
   * @type {number}
   * @memberof AiModelWithAssessment
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof AiModelWithAssessment
   */
  name: string;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof AiModelWithAssessment
   */
  taskType?: TaskTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof AiModelWithAssessment
   */
  readonly latestAssessmentTimestamp: Date | null;
  /**
   *
   * @type {RiskIndicatorSummary}
   * @memberof AiModelWithAssessment
   */
  readonly riskIndicator: RiskIndicatorSummary | null;
  /**
   *
   * @type {Array<TopMetric>}
   * @memberof AiModelWithAssessment
   */
  readonly topRiskMetrics: Array<TopMetric>;
}

/**
 * Check if a given object implements the AiModelWithAssessment interface.
 */
export function instanceOfAiModelWithAssessment(value: object): value is AiModelWithAssessment {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('latestAssessmentTimestamp' in value) || value['latestAssessmentTimestamp'] === undefined) return false;
  if (!('riskIndicator' in value) || value['riskIndicator'] === undefined) return false;
  if (!('topRiskMetrics' in value) || value['topRiskMetrics'] === undefined) return false;
  return true;
}

export function AiModelWithAssessmentFromJSON(json: any): AiModelWithAssessment {
  return AiModelWithAssessmentFromJSONTyped(json, false);
}

export function AiModelWithAssessmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiModelWithAssessment {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    latestAssessmentTimestamp:
      json['latest_assessment_timestamp'] == null ? null : new Date(json['latest_assessment_timestamp']),
    riskIndicator: RiskIndicatorSummaryFromJSON(json['risk_indicator']),
    topRiskMetrics: (json['top_risk_metrics'] as Array<any>).map(TopMetricFromJSON),
  };
}

export function AiModelWithAssessmentToJSON(
  value?: Omit<AiModelWithAssessment, 'id' | 'latestAssessmentTimestamp' | 'riskIndicator' | 'topRiskMetrics'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
  };
}
